<template>
  <FormulateForm v-model="formValues">
    <b-row>
      <b-col md="4" v-for="(field, idx) in fields" :key="idx" class="border">
        <div>
          <FormulateInput v-bind="field">
            <template #prefix> Slot for prefix </template>
          </FormulateInput>
          <div>
            <pre>{{ JSON.stringify({ value: formValues[field.name] }, null, 2) }}</pre>
          </div>
        </div>
      </b-col>
    </b-row>
  </FormulateForm>
</template>

<script>
export default {
  data() {
    return {
      formValues: {},

      fields: [
        {
          type: 'counter',
          label: 'Without Value',
          name: 'no-value',
        },
        {
          type: 'counter',
          label: 'With Default Value',
          value: 0,
          name: 'default',
        },
        {
          type: 'counter',
          label: 'With Min, Max, and Step',
          name: 'min-max-step',
          value: 10,
          min: 0,
          max: 20,
          step: 2,
        },
      ],
    }
  },
}
</script>
